function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineIntegration, convertIntegrationFnToClass, hasTracingEnabled } from '@sentry/core';
import { GLOBAL_OBJ, consoleSandbox, arrayify } from '@sentry/utils';
import { DEFAULT_HOOKS } from './constants.js';
import { attachErrorHandler } from './errorhandler.js';
import { createTracingMixins } from './tracing.js';
var globalWithVue = GLOBAL_OBJ;
var DEFAULT_CONFIG = {
  Vue: globalWithVue.Vue,
  attachProps: true,
  logErrors: true,
  hooks: DEFAULT_HOOKS,
  timeout: 2000,
  trackComponents: false
};
var INTEGRATION_NAME = 'Vue';
var _vueIntegration = function _vueIntegration() {
  var integrationOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    setup: function setup(client) {
      _setupIntegration(client, integrationOptions);
    }
  };
};
var vueIntegration = defineIntegration(_vueIntegration);

/**
 * Initialize Vue error & performance tracking.
 *
 * @deprecated Use `vueIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
var VueIntegration = convertIntegrationFnToClass(INTEGRATION_NAME, vueIntegration);
function _setupIntegration(client, integrationOptions) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_CONFIG), client.getOptions()), integrationOptions);
  if (!options.Vue && !options.app) {
    consoleSandbox(function () {
      // eslint-disable-next-line no-console
      console.warn("[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured.\nUpdate your `Sentry.init` call with an appropriate config option:\n`app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2).");
    });
    return;
  }
  if (options.app) {
    var apps = arrayify(options.app);
    apps.forEach(function (app) {
      return vueInit(app, options);
    });
  } else if (options.Vue) {
    vueInit(options.Vue, options);
  }
}
var vueInit = function vueInit(app, options) {
  // Check app is not mounted yet - should be mounted _after_ init()!
  // This is _somewhat_ private, but in the case that this doesn't exist we simply ignore it
  // See: https://github.com/vuejs/core/blob/eb2a83283caa9de0a45881d860a3cbd9d0bdd279/packages/runtime-core/src/component.ts#L394
  var appWithInstance = app;
  var isMounted = appWithInstance._instance && appWithInstance._instance.isMounted;
  if (isMounted === true) {
    consoleSandbox(function () {
      // eslint-disable-next-line no-console
      console.warn('[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`.');
    });
  }
  attachErrorHandler(app, options);
  if (hasTracingEnabled(options)) {
    app.mixin(createTracingMixins(_objectSpread(_objectSpread({}, options), options.tracingOptions)));
  }
};
export { VueIntegration, vueIntegration };